module.exports = __webpack_public_path__ + "img/acw1.d5c4dc64.png";